import { type DbmsInfo } from '@nx/state/desktop';
import { isNullish } from '@nx/stdlib';
import { memo, useCallback, useState } from 'react';

import { InstanceCard } from './instance-card/instance-card';
import { CreateInstanceProgress } from './instance-card/instance-create-progress';
import type { InstanceDetailsTab } from './instance-details';
import { InstanceDetails } from './instance-details';

interface InstanceTableProps {
  isCompact?: boolean;
  instances: DbmsInfo[];
  onConnectionSuccess?: () => void;
}

const InstanceTableComponent = ({ instances, isCompact, onConnectionSuccess }: InstanceTableProps) => {
  const [instanceDetails, setInstanceDetails] = useState<DbmsInfo | null>(null);
  const [detailsTab, setDetailsTab] = useState<InstanceDetailsTab | undefined>();

  const onClose = useCallback(() => {
    setInstanceDetails(null);
  }, [setInstanceDetails]);

  return (
    <>
      <div className="flex flex-col gap-3 overflow-y-auto p-3">
        {isNullish(isCompact) && <CreateInstanceProgress />}
        {instances.map((instance) => (
          <InstanceCard
            isCompact={isCompact}
            instance={instance}
            key={instance.id}
            onInstanceDetailsClick={(initialTab?: InstanceDetailsTab) => {
              setInstanceDetails(instance);
              setDetailsTab(initialTab ?? 'overview');
            }}
            onConnectionSuccess={onConnectionSuccess}
          />
        ))}
      </div>
      {!isNullish(instanceDetails) && (
        <InstanceDetails instanceId={instanceDetails.id} initialTab={detailsTab} onClose={onClose} />
      )}
    </>
  );
};

export const InstanceTable = memo(InstanceTableComponent);
